// PageAutodisplayViewLinkEduMobile.jsx
// 모바일 전용 자동 디스플레이 링크 페이지 (전체화면 기능 없음)

import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { palette } from "../../../assets/styles/Palette";
import {
  AUTODISPLAY_SELECTED_CONTENT,
  AUTODISPLAY_ACTIVE_DPI_INFO,
  AUTODISPLAY_EDU_VIEW_DESIGN_CONCEPT,
  AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_TITLE,
  AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_MARKDOWN,
  AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_JSON,
  AUTODISPLAY_EDU_VIEW_CONTENTS_PURPOSE,
  AUTODISPLAY_EDU_VIEW_CONTENTS_TYPE,
  AUTODISPLAY_EDU_VIEW_CONTENTS_MEAL,
  AUTODISPLAY_EDU_VIEW_NUTRITION_MESSAGE,
} from "../../AtomStates";
import { useAtom } from "jotai";
import { viewDetailActivateLinkEduRequest } from "../../../utils/indexedDB";
import MoleculeBackgroundSimpleWide from "../../CreateEducationContentPage/components/molecules/MoleculeBackgroundSimpleWide";
import MoleculeMenuBoard from "../../CreateEducationContentPage/components/molecules/MoleculeMenuBoard";

const PageAutodisplayViewLinkEduMobile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [autoDisplaySelectedContent, setAutoDisplaySelectedContent] = useAtom(
    AUTODISPLAY_SELECTED_CONTENT
  );

  const [autoDisplayActiveDPIInfo, setAutoDisplayActiveDPIInfo] = useAtom(
    AUTODISPLAY_ACTIVE_DPI_INFO
  );

  // URL 파라미터와 쿼리 파라미터 모두 처리
  const { path } = useParams();
  const [viewId, setViewId] = useState(null);
  const [urlChecked, setUrlChecked] = useState(false);
  const [activateTimestamp, setActivateTimestamp] = useState("");
  const [isConnecting, setIsConnecting] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [autoDisplayEduViewDesignConcept, setAutoDisplayEduViewDesignConcept] =
    useAtom(AUTODISPLAY_EDU_VIEW_DESIGN_CONCEPT);
  const [autoDisplayEduViewContentsType, setAutoDisplayEduViewContentsType] =
    useAtom(AUTODISPLAY_EDU_VIEW_CONTENTS_TYPE);
  const [autoDisplayEduViewContentsMeal, setAutoDisplayEduViewContentsMeal] =
    useAtom(AUTODISPLAY_EDU_VIEW_CONTENTS_MEAL);
  const [
    autoDisplayEduViewNutritionMessage,
    setAutoDisplayEduViewNutritionMessage,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_NUTRITION_MESSAGE);

  console.log("📱 모바일 전용 컴포넌트 렌더링 (전체화면 기능 없음)");

  const [
    autoDisplayEduViewContentGeneratorTitle,
    setAutoDisplayEduViewContentGeneratorTitle,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_TITLE);
  const [
    autoDisplayEduViewContentGeneratorMarkdown,
    setAutoDisplayEduViewContentGeneratorMarkdown,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_MARKDOWN);
  const [
    autoDisplayEduViewContentGeneratorJson,
    setAutoDisplayEduViewContentGeneratorJson,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_CONTENT_GENERATOR_JSON);
  const [
    autoDisplayEduViewContentsPurpose,
    setAutoDisplayEduViewContentsPurpose,
  ] = useAtom(AUTODISPLAY_EDU_VIEW_CONTENTS_PURPOSE);

  // viewId 추출 (URL 파라미터 또는 쿼리 파라미터에서)
  useEffect(() => {
    let extractedViewId = null;

    // 1. URL 파라미터에서 추출 (/AutodisplayViewLink/viewId)
    if (path) {
      extractedViewId = path;
    }
    // 2. 쿼리 파라미터에서 추출 (?viewId=xxx)
    else {
      const queryParams = new URLSearchParams(location.search);
      extractedViewId = queryParams.get("viewId");
    }

    setViewId(extractedViewId);
    setUrlChecked(true);
  }, [path, location.search]);

  // 연결 버튼 클릭 핸들러
  useEffect(() => {
    const checkActivateState = async () => {
      try {
        setIsConnecting(true);
        setShowErrorPopup(false);

        const activateTimestamp = Date.now();
        setActivateTimestamp(activateTimestamp);

        const data = {
          viewId: viewId,
          activateCode: "",
          activateLocation: "",
          activateIp: "",
          activateTimestamp: activateTimestamp,
        };

        const response = await viewDetailActivateLinkEduRequest(data);
        console.log("🚀 모바일: ~ checkActivateState ~ response:", response);

        setAutoDisplayEduViewDesignConcept(response.designConcept);
        setAutoDisplayEduViewContentsType(response.contentsType);
        setAutoDisplayEduViewContentsMeal(response.contentGeneratorMeal);
        setAutoDisplayEduViewNutritionMessage(response.contentNutritionMessage);

        setAutoDisplayEduViewContentGeneratorTitle(
          response.contentGeneratorTitle
        );
        setAutoDisplayEduViewContentGeneratorMarkdown(
          response.contentGeneratorMarkdown
        );
        setAutoDisplayEduViewContentGeneratorJson(
          response.contentGeneratorJson
        );
        setAutoDisplayEduViewContentsPurpose(response.contentsPurpose);
      } catch (error) {
        console.error("모바일: 연결 중 오류 발생:", error);

        // 서버 응답 메시지 추출
        const serverMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "연결 중 오류가 발생했습니다. 다시 시도해주세요.";

        setErrorMessage(serverMessage);
        setShowErrorPopup(true);
      } finally {
        setIsConnecting(false);
      }
    };

    if (viewId) {
      checkActivateState();
    }
  }, [viewId]);

  return (
    <FullScreenContainer>
      <>
        {autoDisplayEduViewContentsType === "meal" ? (
          <ComponentWrapper>
            <ComponentContainer>
              <MoleculeMenuBoard
                backgroundImage={autoDisplayEduViewDesignConcept}
                menuData={autoDisplayEduViewContentsMeal}
                noticeText={autoDisplayEduViewNutritionMessage}
              />
            </ComponentContainer>
          </ComponentWrapper>
        ) : (
          <ComponentWrapper>
            <ComponentContainer>
              <MoleculeBackgroundSimpleWide
                contentsDesignConcept={autoDisplayEduViewDesignConcept}
                title={autoDisplayEduViewContentGeneratorTitle}
                content={autoDisplayEduViewContentGeneratorMarkdown}
              />
            </ComponentContainer>
          </ComponentWrapper>
        )}
      </>
    </FullScreenContainer>
  );
};

export default PageAutodisplayViewLinkEduMobile;

// 스타일 컴포넌트들 (원래 코드 기반)
const FullScreenContainer = styled.div`
  min-height: 100vh;
  margin: 0;
  padding: 0;
  background: white;
  overflow: visible;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  /* 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  z-index: 9999;
`;

const LoadingSpinner = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid #333;
  border-top: 4px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoadingText = styled.div`
  color: black;
  font-size: 18px;
  font-weight: 600;
`;

const LoadingSubText = styled.div`
  color: #666;
  font-size: 14px;
  text-align: center;
`;

// 실제 차지하는 공간을 조정하는 wrapper (모바일은 항상 3840x2160)
const ComponentWrapper = styled.div`
  width: 3840px;
  height: 2160px;
  overflow: hidden;
  margin: 0 auto;
`;

const ComponentContainer = styled.div`
  width: 3840px;
  height: 2160px;
  background: white;
  position: relative;
  overflow: visible;

  /* 모바일 뷰포트 크기에 맞게 스케일링 (항상 3840x2160 기준) */
  transform-origin: top left;
  transform: scale(min(calc(100vw / 3840), calc(100vh / 2160)));

  @media (max-width: 4000px) {
    transform: scale(
      min(calc((100vw - 40px) / 3840), calc((100vh - 100px) / 2160))
    );
  }
`;

const StyledMainDescription = styled.span`
  color: black;
  font-size: 32px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 48px;
  word-wrap: break-word;
  text-align: start;
`;

const StyledThickLine = styled.div`
  align-self: stretch;
  height: 0px;
  outline: 3px black solid;
  outline-offset: -2px;
`;

const StyledSectionTitle = styled.span`
  width: 144px;
  color: black;
  font-size: 32px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 48px;
  word-wrap: break-word;
  text-align: start;
`;

const StyledSectionContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledBulletItem = styled.div`
  width: 688px;
  color: black;
  font-size: 32px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 48px;
  word-wrap: break-word;
  text-align: start;
  padding-left: 32px;
  text-indent: -22px;
`;

const StyledThinLine = styled.div`
  align-self: stretch;
  height: 0px;
  outline: 1px black solid;
  outline-offset: 0px;
`;

const StyledSectionRow = styled.div`
  justify-content: flex-start;
  align-items: flex-start;
  gap: 32px;
  display: inline-flex;
`;

const StyledContentContainerForModern = styled.div`
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: inline-flex;
`;
